module.exports = __webpack_public_path__ + "static/media/user.cb975218.svg";